export const baseUrl = `https://6k79tb0qyb.execute-api.ap-south-1.amazonaws.com/dev/post-contact-us`
